import CompanyInfo from './CompanyInfo.vue'
import FriendlyReminder from './FriendlyReminder.vue'
import KeywordVerification from './KeywordVerification.vue'
import SureKeyWordFiles from './SureKeyWordFiles.vue'
import CollectionEffect from './CollectionEffect.vue'
import PDFReport from './PDFReport.vue'
import OptimizeAIprompt from './OptimizeAIprompt.vue'
import CorporateInformation from './CorporateInformation.vue'
import UserKeyword from './UserKeyword.vue'
import NewsKeyWord from './NewsKeyWord.vue'
import PublishCreate from './PublishCreate.vue'
import PublishResult from './PublishResult.vue'
import PublishPlan from './PublishPlan.vue'
import OptimizeAssAIprompt from './OptimizeAssAIprompt.vue'
import MonthlyReport from './MonthlyReport.vue'
import ModelInclusion from './ModelInclusion.vue'
import KeywordReport from './KeywordReport.vue'
import WeeklyReport from './WeeklyReport.vue'

export default {
  CompanyInfo,
  FriendlyReminder,
  KeywordVerification,
  SureKeyWordFiles,
  CollectionEffect,
  PDFReport,
  OptimizeAIprompt,
  CorporateInformation,
  UserKeyword,
  NewsKeyWord,
  PublishCreate,
  PublishResult,
  PublishPlan,
  OptimizeAssAIprompt,
  MonthlyReport,
  ModelInclusion,
  KeywordReport,
  WeeklyReport,
}
